var map = {
	"./americano.webp": 8447,
	"./boulevardier.webp": 4394,
	"./campari-soda.webp": 1102,
	"./campari-spritz.webp": 8198,
	"./mi-to.webp": 3937,
	"./negroni.webp": 4630,
	"./other/americano.webp": 2414,
	"./other/boulevardier.webp": 4316,
	"./other/campari-soda.webp": 8444,
	"./other/mi-to.webp": 8860,
	"./other/negroni.webp": 8707,
	"./other/shakerato.webp": 7521,
	"./other/spritz.webp": 5687,
	"./shakerato.webp": 5128,
	"./spritz.webp": 2640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;